import BaseService from "./BaseService";

export default class ObjectService extends BaseService {
  constructor() {
    super();
  }

  async updateStatus(data: any, isSelector: boolean) {
    data.EventId = window.redseats.eventKey;
    let headers;
    if (isSelector) {
      const selector = JSON.parse(sessionStorage.getItem("rs_selector"));
      headers = {
        selectorToken: selector.token,
      };
    }

    const result = await super.callApi(
      `object/canvas/status`,
      "Post",
      data,
      headers
    );

    if (result.statusCode != "200") return false;

    return result.data[0].statusCode == "200";
  }
}
